import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '../../_shared/shared.module';

@Component({
  selector: 'app-pdf-dialog',
  templateUrl: './pdf-dialog.component.html',
  styleUrls: ['./pdf-dialog.component.scss'],
  standalone: true,
  imports: [SharedModule],
})
export class PdfDialogComponent {
  pdfSrc: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { pdfSrc: ArrayBuffer; title: string }
  ) {
    this.pdfSrc = data.pdfSrc;
  }
}
